import { Injectable } from "@angular/core"
import { from, mergeMap, Observable } from "rxjs"
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from "@angular/common/http"
//import { AuthService } from "@spotter/services/user/auth-service"
import { StorageService } from "@spotter/services/internal/storage-service"



@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(public storage: StorageService) {

    }
    intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.storage.get('token')).pipe(
            mergeMap((token) => {
                if (!token)
                {
                    console.warn('No token stored');
                    return handler.handle(request);
                }

                const clonedRequest = request.clone({
                    setHeaders: {
                    //    'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                return handler.handle(clonedRequest);
            })
        );
    }
}
